import cookie from "cookie";

export const mergeNewCookies = (existingCookies: string, newCookies: string[] | Record<string, string>) => {
  // Convert the existing cookies into a key-value object
  const existingCookieObj = cookie.parse(existingCookies);
  let newCookieObj: Record<string, string> = {};

  if (Array.isArray(newCookies)) {
    // Convert the new cookies into a key-value object
    newCookieObj = Object.assign({}, ...newCookies.map((newCookie) => cookie.parse(newCookie)));
  } else {
    newCookieObj = newCookies;
  }

  // Convert the merged cookie object back to a string
  const mergedCookiesObj = { ...existingCookieObj, ...newCookieObj };
  const mergedCookies = Object.entries(mergedCookiesObj)
    .map(([key, value]) => cookie.serialize(key, value))
    .join("; ");

  return mergedCookies;
};
